import React from 'react';
import {Prelead} from 'api';

interface Props {
  row: any;
}

const ActivityMailCampaignMailOpensCountCell = ({row}: Props) => {
  const prelead: Prelead = row.original.prelead;

  return <>{prelead.activityMailCampaignMailOpensCount}</>;
};

export default ActivityMailCampaignMailOpensCountCell;
